import type { NotifyTranslation } from "./en.notify";

const notifyUz: NotifyTranslation = {
  notifications: {
    title: "Bildirishnomalar",
    open: "Bildirishnomalar",
    unreadCount: "O‘qilmagan: {{count}}",
    markAllRead: "Hammasini o‘qilgan deb belgilash",
    seeAll: "Hammasini ko‘rish",
    empty: "Yangi bildirishnoma yo‘q",
    emptyBody: "Vazifalar sizga tayyor bo‘lganda, raundlar tugaganda yoki sizning xatolaringiz o‘zgarganda xabar beramiz.",
    onlyUnread: "Faqat o‘qilmaganlar",
    loadMore: "Yana yuklash",
    unread: "O‘qilmagan",
    detail: {
      back: "Barcha bildirishnomalar",
      open: "Ochish",
      notFound: "Bunday bildirishnoma yo‘q yoki u sizniki emas.",
      delivery: "Yetkazish",
      inApp: "Mixla",
      telegram: "Telegram",
      push: "Brauzer push",
      status: { pending: "Yuborilmoqda…", sent: "Yetkazildi", failed: "Xatolik", skipped: "Yuborilmadi" },
      inAppDelivered: "Bildirishnomalaringizda",
      skippedTelegram: "Telegram ulanmagan",
      skippedPush: "Hech bir brauzerda push yoqilmagan",
    },
    channels: {
      title: "Bildirishnomalar",
      intro: "Barcha bildirishnomalar Mixla’ga keladi. Ularni Telegramda va brauzer xabarlari sifatida ham olishingiz mumkin.",
      telegramTitle: "Telegram",
      telegramHint: "Bildirishnomalarni @{{bot}} xabarlari sifatida oling.",
      telegramOff: "Bu serverda Telegram sozlanmagan.",
      connect: "Telegramni ulash",
      connectedAs: "{{name}} sifatida ulangan",
      connectedSince: "Ulangan: {{time}}",
      waiting: "Telegram ochildi: u yerda «Start» tugmasini bosing. Ulanganingizdan so‘ng sahifa yangilanadi.",
      openAgain: "Telegramni ochish",
      checkAgain: "«Start» ni bosdim",
      disconnect: "Uzish",
      disconnected: "Telegram uzildi",
      connectedToast: "Telegram ulandi",
      pushTitle: "Brauzer push",
      pushHint: "Mixla ochiq bo‘lmaganda shu brauzerda chiqadigan xabarlar.",
      pushOn: "Shu brauzer uchun yoqilgan.",
      pushBlocked: "Bu sayt uchun bildirishnomalar taqiqlangan. Brauzerning sayt sozlamalarida ruxsat bering va qayting.",
      pushUnsupported: "Bu brauzer push qabul qila olmaydi. iPhone’da avval Mixla’ni Bosh ekranga qo‘shing.",
      pushFailed: "Bu brauzerda pushni yoqib bo‘lmadi.",
      pushToggle: "Shu brauzer uchun push",
    },
  },
  search: {
    open: "Qidirish",
    label: "Mixla bo‘yicha qidirish",
    placeholder: "Vazifa, test holati, xato yoki loyihani qidiring…",
    minChars: "Kamida 2 ta belgi kiriting.",
    noResults: "«{{q}}» bo‘yicha hech narsa topilmadi.",
    searching: "Qidirilmoqda…",
    groups: { project: "Loyihalar", task: "Vazifalar", case: "Test holatlari", bug: "Xatolar" },
    quickTitle: "O‘tish",
    quick: { inbox: "Kiruvchilar", projects: "Loyihalar", notifications: "Bildirishnomalar", profile: "Profil" },
    hint: "↑↓ — tanlash · Enter — ochish · Esc — yopish",
  },
  gitlabAdmin: {
    title: "GitLab",
    connection: "Ulanish",
    notConnected: "Ulanmagan",
    statusConnected: "Ulangan",
    tokenRejected: "Token rad etildi",
    unreachable: "Oxirgi tekshiruv o‘tmadi",
    connectIntro: "Mixla’ni GitLab’ga ulang, shunda kartochkalarda branch’lar, merge request’lar, pipeline’lar va joylashlar ko‘rinadi.",
    reconnectIntro: "GitLab uzilgan, uning repozitoriylari va bog‘lanishlari saqlangan. Xuddi shu hostga qayta ulanganda ishlatilayotgan repozitoriylar uchun webhook’lar yana ro‘yxatdan o‘tkaziladi.",
    baseUrl: "GitLab manzili",
    token: "Kirish tokeni",
    tokenHint: "Repozitoriylarda Maintainer huquqi bor foydalanuvchining api ruxsatli tokeni. U shifrlangan holda saqlanadi va boshqa ko‘rsatilmaydi.",
    connect: "Ulash",
    connected: "GitLab ulandi",
    publicUrlMissing: "MIXLA_PUBLIC_URL https manzil emas, shuning uchun GitLab Mixla’ga webhook yubora olmaydi. Uni serverga xizmat ko‘rsatuvchi kishi sozlashi kerak.",
    tokenRejectedBody: "GitLab tokenni rad etdi, shuning uchun Mixla undan o‘qiy olmaydi va webhook’larni yangilay olmaydi. Davom etish uchun tokenni almashtiring. Repozitoriylar va bog‘lanishlar saqlanadi.",
    lastError: "Oxirgi tekshiruv o‘tmadi: {{error}}",
    version: "GitLab versiyasi",
    tokenOwner: "Token egasi",
    connectedAt: "Ulangan",
    lastChecked: "Oxirgi tekshiruv",
    test: "Ulanishni tekshirish",
    testPassed: "GitLab javob berdi, token ishlayapti",
    replaceToken: "Tokenni almashtirish",
    replaceBody: "Webhook’lar va repozitoriylar o‘zgarmaydi.",
    tokenReplaced: "Token almashtirildi",
    rotate: "Webhook sirlarini yangilash",
    rotateTitle: "Webhook sirlari yangilansinmi?",
    rotateBody: "Har bir repozitoriy yangi sir oladi va Mixla uning webhook’ini GitLab orqali yangilaydi. Yangilab bo‘lmagan webhook’lar shu yerda ko‘rsatiladi.",
    rotated: "Yangilangan webhook sirlari: {{count}}",
    disconnect: "Uzish",
    disconnectTitle: "GitLab uzilsinmi?",
    disconnectBody: "Token va barcha webhook sirlari o‘chiriladi, webhook’lar GitLab’dan olib tashlanadi. Repozitoriylar, bog‘lanishlar va qoidalar qoladi, lekin qayta ulanmaguncha kartochkalar yangilanmaydi.",
    disconnected: "GitLab uzildi",
    hookFailures: "Ba’zi webhook’larni o‘zgartirib bo‘lmadi:",
    allowedTitle: "Ruxsat etilgan guruhlar va repozitoriylar",
    allowedIntro: "Loyiha menejerlari repozitoriylarni shu ro‘yxatdan tanlaydi. Guruh ichidagi hamma narsani o‘z ichiga oladi.",
    allowedEmpty: "Hozircha hech narsaga ruxsat berilmagan, shuning uchun loyihalar repozitoriy qo‘sha olmaydi.",
    allowedKind: "Turi",
    allowedKinds: { group: "Guruh", repo: "Repozitoriy" },
    allowedPath: "GitLab’dagi yo‘l",
    allowedAdded: "Ro‘yxatga qo‘shildi",
    allowedRemove: "{{path}} ni olib tashlash",
    allowedRemoved: "Olib tashlandi. Loyihalarga qo‘shilgan repozitoriylar qoladi.",
  },
  gitlabProject: {
    notConnectedTitle: "GitLab ulanmagan",
    notConnectedAsk: "GitLab’ni faqat platforma menejeri ulay oladi. Undan so‘rang, shundan so‘ng bu yerda loyiha repozitoriylarini tanlashingiz mumkin.",
    notConnectedManager: "Avval GitLab’ni butun platforma uchun ulang, shundan so‘ng bu yerda loyiha repozitoriylarini tanlashingiz mumkin.",
    openAdmin: "GitLab sozlamalarini ochish",
    disconnected: "GitLab uzilgan, shuning uchun bu repozitoriylar yangilanmayapti. Uni platforma menejeri qayta ulashi mumkin.",
    reposTitle: "Repozitoriylar",
    intro: "Bu repozitoriylardagi branch va merge request’lar vazifalarga kalit orqali bog‘lanadi. Bog‘lash repozitoriy qo‘shilganda boshlanadi, shuning uchun avvalgi ishlar GitLab ular bo‘yicha yangi faollik haqida xabar berganda ko‘rinadi.",
    empty: "Hozircha repozitoriy yo‘q. Ishlari loyiha kartochkalarida ko‘rinishi uchun repozitoriy qo‘shing.",
    addRepo: "Repozitoriy qo‘shish",
    search: "Repozitoriy qidirish",
    searchPlaceholder: "Nomi yoki yo‘li",
    noResults: "Repozitoriy topilmadi. Bu yerda faqat platforma menejeri ruxsat bergan guruh va repozitoriylar ko‘rinadi.",
    added: "Qo‘shilgan",
    repoAdded: "{{name}} qo‘shildi",
    removeRepo: "{{name}} ni olib tashlash",
    removeRepoBody: "Uning faolligi bu loyihaga kelmay qoladi. Yaratilgan bog‘lanishlar vazifalarda qoladi.",
    repoRemoved: "Repozitoriy olib tashlandi",
    hook: { active: "Webhook ishlayapti", failing: "Webhook’da nosozlik", disabled: "Webhook o‘chirilgan", none: "Webhook yo‘q" },
    hookError: "GitLab javobi: {{error}}",
    hookDisabledHint: "GitLab takroriy nosozliklardan so‘ng bu webhook’ni o‘chirib qo‘ydi.",
    registerAgain: "Webhook’ni qayta ro‘yxatdan o‘tkazish",
    hookRegistered: "Webhook ro‘yxatdan o‘tkazildi",
    syncFailing: "Yetishib olish sinxronlashida nosozlik: {{error}}",
    lastEvent: "Oxirgi hodisa: {{time}}",
    noEvents: "Hozircha hodisa yo‘q",
    lastSynced: "sinxronlandi: {{time}}",
    rulesTitle: "Qoidalar",
    rulesIntro: "GitLab biror narsa haqida xabar berganda qoidalar vazifalarni o‘tkazadi. Ular vazifani faqat oldinga siljitadi, hech qachon tayyor yoki yopilgan holatdan va sinovdan chiqarmaydi. Birlashtirish yoki joylash qoidasi vazifaning barcha tasdiqlangan merge request’larini kutadi. Yoqilgan qoida bo‘lmasa, GitLab vazifa holatini o‘zgartirmaydi.",
    rulesEmpty: "Qoidalar yo‘q. GitLab faolligi vazifalarni siljitmaydi.",
    addRule: "Qoida qo‘shish",
    editRule: "Qoidani tahrirlash",
    events: { mr_opened: "MR ochildi", mr_merged: "MR birlashtirildi", deployed: "Muhitga joylandi", deployedTo: "{{environment}} muhitiga joylandi" },
    statusGone: "O‘chirilgan holat",
    ruleOn: "Yoqilgan",
    ruleOff: "O‘chirilgan",
    ruleDisabled: "Ishlay olmaydi",
    ruleDisabledHint: "Qoida vazifalarni o‘tkazadigan holat o‘chirilgan. Qoidani tahrirlab, boshqasini tanlang.",
    notSeen: "Hali ko‘rilmagan",
    notSeenHint: "Loyiha repozitoriylarida bu muhitga joylash hali ko‘rilmagan. Nomi aynan mos kelishi kerak.",
    environmentHint: "Loyiha repozitoriylarida ko‘rilgan muhitni tanlang yoki nomini yozing. Nomi aynan mos kelishi kerak.",
    ruleEvent: "Qachon",
    ruleEventFixed: "Buni o‘zgartirib bo‘lmaydi. Boshqa hodisa uchun yana bir qoida qo‘shing.",
    ruleEnvironment: "Muhit",
    ruleStatus: "Vazifani o‘tkazish",
    pickStatus: "Holatni tanlang",
    required: "Majburiy",
    bugsTitle: "Xatolar",
    fixOnMerge: "Bog‘langan xatolarni merge’da tuzatilgan deb belgilash",
    fixOnMergeHint: "Ochiq xato bog‘langan merge request’laridan birortasi ochiq qolmasa va kamida bittasi o‘z reposining asosiy branchiga qo‘shilsa, tuzatilgan holatiga o‘tadi. Egasi yo‘q xato joyida qoladi va faoliyatiga izoh qo‘shiladi.",
    withoutKeyTitle: "Kalitsiz qo‘shilganlar",
    withoutKeyIntro: "So‘nggi 30 kunda qo‘shilgan, {{key}}-12 yoki {{key}}BUG-12 kabi kaliti yo‘q merge request’lar, shuning uchun ular hech qaysi vazifa yoki xatoga tegishli emas. release/* branchlari ko‘rsatilmaydi. Mixla bu haqda GitLab’ga hech narsa yozmaydi.",
    withoutKeyEmpty: "Bu yer bo‘sh. So‘nggi barcha merge’larda kalit bor.",
    ruleStartsOff: "Yangi qoidalar o‘chirilgan holda boshlanadi. Tayyor bo‘lganingizda yoqing.",
    ruleCreated: "Qoida qo‘shildi. Uni yoqmaguningizcha o‘chirilgan bo‘ladi.",
    ruleSaved: "Qoida saqlandi",
    removeRule: "Qoidani olib tashlash",
    removeRuleBody: "«{{rule}}» vazifalarni siljitmay qo‘yadi. Allaqachon o‘tkazilgan vazifalar joyida qoladi.",
    ruleRemoved: "Qoida olib tashlandi",
  },
  channels: {
    title: "Kanallar",
    intro: "Jamoaviy xabarlarni Slack kanaliga yoki Telegram guruhiga yuboring: yangi xatolar, sinovga tayyor vazifalar, yakunlangan raundlar.",
    add: "Kanal qo‘shish",
    edit: "Kanalni tahrirlash",
    empty: "Hozircha kanal yo‘q.",
    kind: "Turi",
    kinds: { slack: "Slack", telegram: "Telegram" },
    name: "Nomi",
    namePlaceholder: "masalan, #payments-qa",
    webhookUrl: "Slack webhook manzili",
    webhookHint: "https://hooks.slack.com/services/… — Slackda kiruvchi webhook yarating.",
    botToken: "Bot tokeni",
    chatId: "Chat ID",
    telegramHelp:
      "1. @BotFather orqali bot yarating va tokenini nusxalang.\n2. Botni guruhingizga qo‘shing.\n3. Guruh chat ID sini oling (masalan, xabar yuborib, api.telegram.org/bot<token>/getUpdates ni oching); odatda -100 bilan boshlanadi.",
    replaceCredentials: "Kirish ma’lumotlarini almashtirish",
    credentialsHint: "Joriylarini saqlash uchun bo‘sh qoldiring.",
    events: "Xabar berish",
    eventNames: {
      bug_reported: "Yangi xato haqida xabar",
      bug_closed: "Xato yopildi",
      task_ready_for_test: "Vazifa sinovga tayyor",
      task_ready_for_retest: "Qayta sinov so‘raldi",
      round_finished: "Raund yakunlandi",
      task_passed: "Vazifa o‘tdi",
    },
    minSeverity: "Xatolar haqida xabarlar",
    severityOptions: { s1: "Faqat S1", s2: "S1 va S2", s3: "S1 dan S3 gacha", s4: "Barcha darajalar" },
    enabled: "Yoqilgan",
    disabled: "To‘xtatilgan",
    sendTest: "Sinov xabari",
    testSent: "Sinov xabari yuborildi",
    testFailed: "Sinov xabari yuborilmadi",
    lastOk: "Oxirgi xabar yetkazildi: {{time}}",
    lastError: "Oxirgi yuborish muvaffaqiyatsiz: {{error}}",
    never: "Hali hech narsa yuborilmagan",
    remove: "O‘chirish",
    removeTitle: "{{name}} o‘chirilsinmi?",
    removeBody: "Mixla bu kanalga yozishni to‘xtatadi. Chatning o‘ziga ta’sir qilmaydi.",
    created: "Kanal qo‘shildi",
    saved: "Kanal saqlandi",
    removed: "Kanal o‘chirildi",
    pickEvent: "Kamida bitta xabar turini tanlang.",
    required: "Majburiy",
    managersOnly: "Kanallarni faqat loyiha menejerlari boshqaradi.",
  },
};

export default notifyUz;
